module.exports = "/img/_/_/_/assets/images/creeper/book/rare//1.jpg?4cceb8e3c6cae8720b01e94a6370b084";